<header role="banner">
  <span class="cdk-visually-hidden" aria-live="polite" aria-atomic="true">{{ helpDialogStatus }}</span>
  <div class="toolbar" fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="row" fxLayoutAlign="start center">
      <prep-toolbar-sidenav-mobile-toggle *ngIf="!hideSidebarNavigation" (openSidenav)="openSidenav.emit()"></prep-toolbar-sidenav-mobile-toggle>
      <img *ngIf="dynamicimgUrlValid" [src]="dynamicImgUrl" alt="{{logoAlttext}}" height="45"
        style="margin-right: 15px;" />
      <!-- Welcome message and roles -->
      <span class="prep-toolbar-user-head">
        {{LangTextData?.htmlLabel.welcome}} {{ account_user_name }}
        <!-- WCAG 4.1.2: aria-label is not allowed on the generic role
             (a plain <span>); the visible interpolated text below is
             already the element's accessible name. The truthy guard on
             the i18n value prevents an empty named span from rendering
             before LangTextData has loaded. -->
        <span *ngIf="isOrganizationAdmin && LangTextData?.htmlLabel?.orgAdmin">{{LangTextData?.htmlLabel.orgAdmin}}</span>
        <span *ngIf="!isSuperAdmin && isDepartmentAdmin && LangTextData?.htmlLabel?.deptAdmin">{{LangTextData?.htmlLabel.deptAdmin}}</span>
      </span>
      <!-- <span *ngIf="accountToconsole" style="margin-left: 10px;">
        <a href="https://stanford.prep.continualengine.com/" target="_blank" rel="noopener noreferrer"
          aria-label="Opens example website in a new tab" role="link" class="external-link"
          style="color: rgb(19, 110, 248);text-decoration: underline;font-weight: bold;">
          {{accountConsoleLabel}}
        </a>

      </span> -->
      <span *ngIf="!hideSidebarNavigation && account.components.length != 0" style="margin-left: 10px;">
        <a [routerLink]="['/vt-dashboard']" rel="noopener noreferrer"
          aria-label="Opens example website in a new tab" role="link" class="external-link"
          style="    color: rgb(19, 110, 248);text-decoration: underline;font-weight: bold;">
          Home
        </a>

      </span>
      <!-- License expiry warning -->
      <p *ngIf="liccenseExpired" style="font-size: large;font-weight: bold;color: red;" role="alert"
        aria-live="assertive">
        {{LangTextData?.htmlLabel.licenseExpired}}
      </p>
    </div>
    <div fxLayout="row">
      <!-- "Start work" guided workflow launcher (renders nothing unless the workflow is offered to this user) -->
      <guided-workflow-launcher *ngIf="!hideSidebarNavigation && account.components.length != 0" fxHide.xs class="toolbar-button"></guided-workflow-launcher>
      <prep-toolbar-resources fxHide.xs *ngIf="prep_tool_enabled" class="toolbar-button"></prep-toolbar-resources>
      <!-- Notifications -->
      <prep-toolbar-notifications *ngIf="router.url.includes('dashboard')" class="toolbar-button"></prep-toolbar-notifications>
      <!-- Help Button -->
      <span class="toolbar-button">
        <button #helpBtn class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" 
          [attr.aria-label]="LangTextData?.tooltipLabel.toolBoxHelp"
          (click)="HelpClick(helpBtn)" [matTooltip]="LangTextData?.tooltipLabel.toolBoxHelp"
          matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
          <mat-icon aria-hidden="true">help_outline</mat-icon>
        </button>
      </span>
      <!-- Release Notes -->
      <prep-toolbar-release-notes fxHide.xs fxHide.sm class="toolbar-button"></prep-toolbar-release-notes>
      <!-- Fullscreen toggle -->
      <prep-toolbar-fullscreen-toggle fxHide.xs fxHide.sm class="toolbar-button"></prep-toolbar-fullscreen-toggle>
      <!-- Search -->
      <prep-toolbar-search fxHide fxHide.xs fxHide.sm fxShow.gt-sm fxHide.gt-md class="toolbar-button"
        aria-label="Search"></prep-toolbar-search>
      <!-- User Profile Menu -->
      <prep-language-selector *ngIf="!hideSidebarNavigation" class="toolbar-button" aria-label="Language Selector"></prep-language-selector>
      <prep-toolbar-user class="toolbar-button"></prep-toolbar-user>
    </div>
  </div>
</header>